import * as React from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import '../../Algolia/components/FacetsMobile/FacetsMobile.js';
import '@grandvisionhq/state';
import '../../types.js';
import '../../Algolia/components/CurrentRefinements/CurrentRefinements.js';
import '../../Algolia/components/FacetInputList/ConnectedFacetInputList.js';
import '../../Algolia/components/FacetInputPriceRange/ConnectedFacetInputPriceRange.js';
import '../../Algolia/components/VirtualFacets/VirtualFacets.js';
import SortBy from '../../Algolia/components/SortBy/SortBy.js';
import '@swc/helpers';
import 'algoliasearch/lite';
import 'react-instantsearch-dom';
import 'react-instantsearch-dom/server';
import 'lodash/merge';
import '@grandvisionhq/utils';
import '../../Algolia/utils/query-string.js';
import '../../Algolia/AlgoliaDataProvider.js';
import '../../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/products';
import '../../CrossSellProducts/utils/create-algolia-filters.js';
import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';

const SearchOrderBy = ({ allSearchResults , amountOfHitsLabel , showSortBy , activeIndex , sortIndices  })=>{
    const suggestions = getResultsByIndex(allSearchResults, (activeIndex === null || activeIndex === void 0 ? void 0 : activeIndex.name) || '');
    const amountOfHits = `${(suggestions === null || suggestions === void 0 ? void 0 : suggestions.nbHits) || 0} ${amountOfHitsLabel}`;
    if (!sortIndices.length || !sortIndices[0]) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-results"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__amount-hits"
    }, amountOfHits), showSortBy && sortIndices && sortIndices.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-by"
    }, /*#__PURE__*/ React.createElement(SortBy, {
        defaultRefinement: sortIndices[0].value,
        items: sortIndices
    })));
};
var SearchOrderBy$1 = connectStateResults(SearchOrderBy);

export { SearchOrderBy, SearchOrderBy$1 as default };
//# sourceMappingURL=SearchOrderBy.js.map
